var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"nametags",attrs:{"title":_vm.title}},_vm._l((_vm.nameTags),function(tag){return _c('nametag',{key:tag,attrs:{"tag":tag}})}),1)}
var staticRenderFns = []

export { render, staticRenderFns }